



























import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  registerEventFromApp,
  listenFromParent,
  sendToParrent,
  ParentEvDataInitRes,
  ParentEvDataOpenRes,
  platform,
  Bridge,
} from '@/common/bridge';
import { onOpenMyRequest, onOpenArticle, onFloatButton, emitFloatButton } from '@/common/eventBus';
import MyRequestComponent from '@/components/MyRequest/index.vue';
import Article from '@/components/Article.vue';
import FloatButton from '@/components/FloatButton.vue';
import ConsentGA from '@/components/ConsentGA.vue';
import { CustomerServiceProvider, MINIMIZE_TIME } from '@/common/config';
import { LoginResult } from './common/types';
import { store } from './store';
import { GA_EVENT_NAME_ENUM, GA_SHOW_CONSENT_BANNER } from './common/gaHelper';
import { bootstrap, setOptions } from 'vue-gtag';
import * as env from '@/common/environment';

const UserModule = namespace('user');
const analyticsConsentModule = namespace('analyticsConsent');

@Component({
  components: {
    MyRequestComponent,
    Article,
    FloatButton,
    ConsentGA,
  },
})
export default class App extends Vue {
  @UserModule.Mutation('initProject') initProject!: Function;
  @UserModule.Mutation('updateLoginStatus') updateLoginStatus!: Function;
  @UserModule.Action('sportyLoginSuccess') sportyLoginSuccess!: Function;

  @analyticsConsentModule.Getter('showConsentBanner') showConsentBanner!: boolean;

  showFloatButton = false;
  showMyRequest = false;
  fetchArticle = false;
  isFromAutocomplete = false;
  articleTitle = '';
  categoryName = '';
  showArticle = false;
  showArticleId: string|number = '';
  articleBody = '';
  articleSectionTitle = '';
  hasInit = false;
  openedChatbot = false;

  created () {
    // Interaction
    registerEventFromApp(); // Need to only call once before listenFromParent, it only used for App(handled internally)

    // Listen
    const onLogin = (data: LoginResult) => {
      if (Object.prototype.hasOwnProperty.call(data, 'bizCode')) {
        if (data.bizCode === 10000) {
          this.sportyLoginSuccess(data);
        }
      } else {
        this.sportyLoginSuccess(data);
      }
    };

    Bridge.onLoginFromPopup(onLogin);
    Bridge.onLoginSuccess(onLogin);

    listenFromParent<ParentEvDataOpenRes>('OPEN', async data => {
      emitFloatButton(false);
      sendToParrent('MINIMIZE', {
        period: MINIMIZE_TIME, // sec
        open: true,
      });
    });
    listenFromParent<ParentEvDataInitRes>('INIT', async data => {
      const { open } = data;
      if (!this.hasInit && !open) { // For INIT event like Sportybet web in home page, should also do minimize
        emitFloatButton(true);
      }
      this.initProject({
        ...data,
        provider: CustomerServiceProvider.PLEASED,
      });

      // open chatbot via INIT event with open=true, for example in WAP, APP
      if (open) {
        this.openedChatbot = true;
      }

      if ((platform === 'wap' || platform === 'web')) {
        if (open) { // For INIT event like Sportybet web in home page, only when open Chatroom/index.vue when it is opened, to reduce API call (ex: /user/createUser, /category/list)
          this.hasInit = true;
        }
      } else { // natvie
        this.hasInit = true;
      }
    });
    // listenFromParent('GO_LIVE_CHAT', (data) => {
    //   this.$router.push({ name: 'chatroom' });
    // });
    sendToParrent('INIT'); // Bridge-INIT-Send
    // For dev test, you can also use demo.html to serve it
    // this.initProject({
    //   isLogin: true,
    //   country: 'ng',
    //   token: 'patron:id:accesstoken:6fde553df8547681dad72cd9368aa540COvZPvKoBOo06G2KcM7zdA7ovPXckSIeNFsQVgWLwUJKYgwD8Tg22rXeV+86ErMyiJIUMwMcKK/GXg9iAzYhOw==',
    //   chatStatus: '',
    //   provider: CustomerServiceProvider.PLEASED,
    //   phone: '',
    //   email: '',
    // }); // 7771110000 test1234ng
    // this.hasInit = true;

    onFloatButton(isOpen => {
      this.showFloatButton = (isOpen && (platform === 'wap' || platform === 'web')); // Only mobile web and desktop can use FloatButton
      if (isOpen === false) {
        this.hasInit = true;

        // open chatbot via FloatButton/OPEN event
        this.openedChatbot = true;

        const chatStore = (store.state as { chat: { isInitialized: boolean }}).chat;

        // If already initialized, then we need to send to redirect page
        if (chatStore.isInitialized) {
          Bridge.redirectToLastEventPage();
        }
      }
    });

    onOpenMyRequest(isOpen => {
      this.showMyRequest = isOpen;
    });
    onOpenArticle(data => {
      this.showArticle = data.isOpen;
      this.showArticleId = data.articleId || '';
      this.articleTitle = data.title || '';
      this.categoryName = data.categoryName || '';
      this.articleBody = data.body || '';
      this.articleSectionTitle = data.sectionTitle || '';
      this.fetchArticle = data.fetchArticle || false;
      this.isFromAutocomplete = data.isFromAutocomplete || false;
    });
  }

  @Watch('openedChatbot')
  onOpenedChatbotChange () {
    if (this.openedChatbot) {
      if (!GA_SHOW_CONSENT_BANNER) {
        const gaId = env.get('gaId');

        if (gaId) {
          setOptions({
            config: {
              id: gaId,
              params: {
                anonymize_ip: true,
                brand: env.get('brandCode'),
                country: env.get('country'),
                platform,
              },
            },
          });

          bootstrap().then((_gtag) => {
            // gtag is undefined here
            this.$gtag.event(GA_EVENT_NAME_ENUM.OPEN_CHATBOT);
          });
        }
      }
    }
  }
}
